<template>
    <div class="devolucoes">
      <g-card
      class="card-form-devolucoes"
      margem="20px"
      :expansivel="true"
      :comecaFechado="false"
      >
      <template #cabecalho>
          <div class="header-filtros">
            <div class="titulo-filtros-cabecalho"> Devoluções </div>
            <div class="header-icons">
              <g-button
              class="trash-box"
              tipo="cinza"
              altura="35px"
              largura="45px"
              icone="icone_lixo.svg"
              tamanhoIcone="15px"
              somenteIcone
              :sombreado="false"
              v-tooltip="'Limpar filtro'"
              v-on:acao="limparFiltro"
              />

              <g-button
              class="buscar-button-header-filtro"
              largura="155px"
              icone="icone_lupa.svg"
              negritoTexto
              tamanhoIcone="15px"
              tamanhoTexto="15px"
              altura="35px"
              gap="10px"
              :sombreado="false"
              @click="buscar"
              >
                  BUSCAR
              </g-button>
            </div>
          </div>
        </template>

        <g-form>
            <div class="devolucoesConteudo espacamento-filtros">
                <div class="codigo-produto">
                    <div class="titulo-conteudo-filtros"> Nome do Produto </div>
                    <PDropDown
                        class="produto-novo-input input-label"
                        v-model="formSearch.NomeProduto"
                        placeholder="Insira o nome de produto"
                        optionLabel="labelProduto"
                        optionValue="produtoId"
                        @filter="getProduto($event.value)"
                        :filter="true"
                        :options="ProdutoArray"
                        />
                </div>

                <div class="situacao">
                    <div class="titulo-conteudo-filtros"> Situação </div>
                    <PDropDown
                        class="situacao-input input-label unidade"
                        placeholder="TODAS"
                        v-model="formSearch.Situacao"
                        :options="situacaoArray"
                        optionLabel="text"
                        optionValue="value"
                        :filter="true"
                        />
                </div>

                <div class="data-recebimento">
                    <div class="titulo-conteudo-filtros"> Data de Recebimento </div>
                    <div class="input-data">
                        <div class="data-inicio">
                            <g-date-input
                            class="data-recebimento-inicio-input input-label"
                            placeholderinput="Data Início"
                            alturainput = "40px"
                            largurainput = "100%"
                            tamanhobotao = "35px"
                            :dataPassadas="true"
                            v-model="formSearch.PeriodoInicio"
                            ></g-date-input>
                        </div>
                        <div class="data-periodo"> à </div>
                        <div class="data-termino">
                            <g-date-input
                            class="data-recebimento-termino-input input-label"
                            placeholderinput="Data Término"
                            alturainput = "40px"
                            largurainput = "100%"
                            tamanhobotao = "35px"
                            :dataPassadas="true"
                            v-model="formSearch.PeriodoFim"
                            ></g-date-input>
                        </div>
                    </div>
                </div>

                <div class="unidade">
                    <div class="titulo-conteudo-filtros"> Unidade </div>
                        <PDropDown
                            class="unidade-input input-label unidade"
                            placeholder="TODAS"
                            :options="EmpresaArray"
                            v-model="formSearch.UnidadeId"
                            optionLabel="nome"
                            optionValue="id"
                        ></PDropDown>
                </div>

                <div class="cliente">
                    <div class="titulo-conteudo-filtros"> Cliente </div>
                        <!-- <PDropDown
                            class="cliente-input input-label"
                            placeholder="Selecione o cliente"
                            :filter="true"
                            optionLabel="nomeFantasia"
                            optionValue="id"
                            v-model="formSearch.ClienteId"
                            :options="ClientesArray"
                            :filterFields="['razaoSocial','codigoExterno','nomeFantasia','situacao','estadoCidade','cnpj']"
                            @filter="buscarClientes($event.value)"
                        >
                            <template #option="slotProps">
                                <cliente-dropdown-item
                                    :dadosCliente="slotProps.option"
                                ></cliente-dropdown-item>
                            </template>
                        </PDropDown> -->
                    <cliente-dropdown
                        class="cliente-input input-label"
                        v-model="formSearch.ClienteId"
                        :empresaId="formSearch.UnidadeId"
                        :representanteId="this.$store.state.representanteSelecionadoId"
                    />
                </div>

            <div class="buscar-button-filtro">
              <g-button
              class="buscar-button"
              largura="100%"
              icone="icone_lupa.svg"
              negritoTexto
              tamanhoIcone="15px"
              tamanhoTexto="15px"
              altura="35px"
              gap="10px"
              :sombreado="false"
              @click="buscar"
              >
                  BUSCAR
              </g-button>
            </div>

            </div>
        </g-form>
    </g-card>

    <g-card paddingDefault="0 0em 1em" :expansivel="false" :temCabecalho="false" class="card-resultado">
        <div v-if="pt1" class="">
            <img
                class="icone-global-imagemfundo"
                src="@/assets/imgs/Ilustracao_erro.svg"
            />
            <div class="texto-padrao-imagemfundo">
                Verifique os filtros e clique em buscar para exibir os resultados
            </div>
        </div>
        <div v-else-if="!pt1">
            <g-data-table
            TextoVazio="Nenhuma Devolução Encontrada"
            Titulo="Devoluções"
            altura="auto"
            :NumeroLinhas="100"
            :colunas="Colunas"
            :valores="devolucoesArray"
            :Filtros="Filtro"
            :EscondeColunaBotao="true"
            campoAgrupador="'empresaCliente'"
            :campoExibicaoGrupo="'empresaCliente'"
            ></g-data-table>
        </div>
    </g-card>

  </div>
</template>

<script>
import ConsultasDevolucoes from './ConsultasDevolucoes.js'
export default ConsultasDevolucoes
</script>

<style scoped>
.header-devolucoes {
    padding: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.devolucoes-titulo {
    color: #4f2c19;
    font-weight: 600;
    text-align: left;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.card-resultado-content {
  display: flex;
  flex-direction: column;
}

.imagem-nenhuma-info {
    margin: 0 auto;
    max-height: 500px;
}

.card-resultado-text-small {
    color: #4F4C4D;
    font-family: Montserrat;
}

.titulo {
  color: #747474;
  text-align: left;
  font-family: Montserrat;
  font-weight: bold;
  white-space: nowrap;
}

.input-label {
  margin-bottom: 15px;
}

.data-recebimento{
  color: #747474;
  font-family: Montserrat;
}

td, th {
  border: 1px solid #e6e6e6;
  text-align: center;
}

@media (min-width: 310px) {
    .buscar-button-header {
      display: none;
    }

    .devolucoesConteudo{
        display: flex;
        flex-direction: column;
    }

    .unidade { grid-area: 1 / 1 / 2 / 2; }
    .cliente { grid-area: 2 / 1 / 3 / 2; }
    .nome-produto {grid-area: 4 / 1 / 5 / 2; }
    .situacao{ grid-area:  3 / 1 / 4 / 2;  }
    .data-recebimento { grid-area: 5 / 1 / 6 / 2;  }

    .buscar-button-filtro {
      display: flex;
      justify-content: center;
      align-items: self-end;
      margin-top: 10%;
      order: 7
    }

    .header-devolucoes {
        display: flex;
    }
    .devolucoes-titulo {
        font-size: 18px;
        margin: 0;
    }
    .titulo {
        font-size: 14px;
    }

    .codigo-produto-input, .nome-produto-input, .situacao-input, .data-inicio, .data-termino, .unidade-input, .cliente-input{
        width: 100%;
    }

    .data-recebimento-input{
        display: grid;
        grid-template-columns: repeat(3, auto);
        grid-template-rows: 100%;
        grid-column-gap: 4%;
    }

    .data-recebimento-inicio { grid-area: 1 / 1 / 2 / 2; }
    .data-recebimento-a { grid-area: 1 / 2 / 2 / 3; align-self: center; }
    .data-recebimento-termino { grid-area: 1 / 3 / 2 / 4; }

    .devolucoesConteudo {
        display: grid;
        grid-template-columns: 1fr;
        grid-column-gap: 50px;
        grid-row-gap: 15px;
    }

    }
    td, th {
        padding: 0.5em 0.3em;
    }

@media (min-width: 368px) {
    .buscar-button {
    width: 60%;
    }
    .imagem-nenhuma-info {
        height: 10rem;
        width: auto;
    }
}

@media (min-width: 600px) {
    .header-icons-devolucoes {
    display: grid;
    grid-template-columns: repeat(2, auto);
    grid-template-rows: 100%;
    grid-column-gap: 10px;
    }
    .buscar-button-header {
        display: block;
    }
    .buscar-button {
        display: none;
    }
    .devolucoesConteudo {
        display: grid;
        grid-template-columns: 46% auto;
        grid-template-rows: 1fr 1fr 1fr;
        grid-column-gap: 50px;
        grid-row-gap: 15px;
    }

    .unidade { grid-area: 1 / 1 / 2 / 2; }
    .cliente { grid-area: 1 / 2 / 2 / 3;}
    .codigo-produto { grid-area: 2 / 1 / 3 / 2; }
    .nome-produto { grid-area: 2 / 2 / 3 / 3; }
    .situacao{  grid-area: 2 / 2 / 3 / 3;}
    .data-recebimento { grid-area: 3 / 1 / 4 / 2; }

    .imagem-nenhuma-info {
    height: 14rem;
    width: auto;
  }

  .devolucoes-titulo {
    margin-left: 20px;
  }

  td, th {
    padding: 0.5em 1.5em;
  }
}

@media (min-width: 801px) {
    .devolucoes-titulo {
        font-size: 20px;
    }
}

@media (min-width: 1025px) {
    .devolucoes-titulo {
        font-size: 22px;
    }

    .devolucoesConteudo{
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;        
        grid-template-rows: auto;
        grid-column-gap: 15px;
        grid-row-gap: 0px;
    }
    .unidade { grid-area: 1 / 1 / 2 / 2; }
    .cliente { grid-area: 1 / 2 / 2 / 3;}
    .situacao{grid-area: 1 / 3 / 2 / 4; }
    .codigo-produto { grid-area: 2 / 1 / 3 / 2; }
    .nome-produto { grid-area: 2 / 2 / 3 / 3; }
    .data-recebimento { grid-area: 2 / 2 / 3 / 3; }

    .card-resultado-text-small {
        font-size: 14px;
    }
    .imagem-nenhuma-info {
        height: 16rem;
        width: auto;
    }
}

@media (min-width: 1281px) {
    .devolucoesConteudo{
        display: grid;
        grid-template-columns: repeat(3, minmax(0.25rem,1fr));
        grid-template-rows: 1fr 1fr;
        grid-column-gap: 15px;
        grid-row-gap: 0px;
    }
    .codigo-produto {  grid-area: 2 / 1 / 2 / 2; }
    .nome-produto { }
    .data-recebimento { grid-area: 2 / 2 / 3 / 3; }
    .situacao{grid-area: 1 / 3 / 2 / 4;}
    .unidade { grid-area: 1 / 1 / 2 / 2; }
    .cliente {grid-area: 1 / 2 / 2 / 3;  }
}

@media (min-width: 1500px) {
     /* .devolucoesConteudo{
        display: grid;
        grid-template-columns: repeat(6 ,minmax(0.25em,1fr));
        grid-template-rows: auto;
        grid-column-gap: 15px;
        grid-row-gap: 0px;
    }
    .unidade { grid-area: 1 / 1 / 2 / 2;}
    .cliente { grid-area: 1 / 2 / 2 / 3;}
    .codigo-produto { grid-area: 1 / 3 / 2 / 4;  }
    .nome-produto { grid-area: 1 / 4 / 2 / 5; }
    .situacao{grid-area: 1 / 5 / 2 / 6;}
    .data-recebimento { grid-area: 1 / 6 / 2 / 7; } */

}

</style>